import { render, staticRenderFns } from "./VDelayList.vue?vue&type=template&id=6c5482c9&scoped=true"
import script from "./VDelayList.vue?vue&type=script&lang=ts"
export * from "./VDelayList.vue?vue&type=script&lang=ts"
import style0 from "./VDelayList.vue?vue&type=style&index=0&id=6c5482c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5482c9",
  null
  
)

export default component.exports